import { render, staticRenderFns } from "./QuestionButton.vue?vue&type=template&id=49abc30f&scoped=true"
import script from "./QuestionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./QuestionButton.vue?vue&type=style&index=0&id=49abc30f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49abc30f",
  null
  
)

export default component.exports